.reactionOption {
  font-size: var(--ant-font-size-lg);
}

.reactionOptionReacted {
  background-color: var(--ant-color-primary-bg);
}

/* Touch screens get the same 44px targets as the comment action links */
@media (pointer: coarse) {
  .reactionOption {
    min-width: 44px;
    min-height: 44px;
  }
}
